import { Store } from "../../@types/contexts/groupContext/store.types";

const initialState: Store = {
	group_number: 220
};

export default initialState;
